import styled from "styled-components/macro";

export const PriceDiscount = styled.div`
  color: #59C1BD;
  text-align: center;
  font-family: Jura;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const OldPrice = styled.div`
  color: rgba(245, 225, 255, 0.74);
  text-align: center;
  font-family: Jura;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-decoration: line-through;
  padding-right: 5px;
`;
export const Price = styled.div`
  color: #FFF;
  text-align: right;
  font-family: Jura;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-right: 0px;
  
  position: relative;
`;
export const PriceAndDiscountContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`;
export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;